var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Name of the key used to store the Intercom Segmentation Info
 * @constant
 * @type {string}
 */
export var INTERCOM_SEGMENTATION_INFO_KEY = 'intercom-segmentation-info';
/**
 * Name that should be provided as the last application name
 * @constant
 * @type {string}
 */
export var INTERCOM_LAST_APPLICATION_NAME = 'platform';
/**
 * Returns the Unix Epoch timestamp
 * @returns {number} - Returns the number of seconds representing the timestamp
 */
export var getLastSeenUnixEpoch = function () {
    return Math.floor(new Date().valueOf() / 1000);
};
/**
 * Executes the data requests to get the settings required to initialize the Intercom component and cached to the session storage
 * @returns {Promise} - Returns a Promise that resolves once all the requests has been completed
 */
export var requestIntercomSegmentationInfoWithCache = function (request) {
    if (request === void 0) { request = {
        requestList: [],
        appID: '',
        mappingResponsesToSegmentationInfo: function () { return null; },
    }; }
    return __awaiter(void 0, void 0, void 0, function () {
        var segmentationInfoJSONStr, segmentationInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    segmentationInfoJSONStr = sessionStorage.getItem(INTERCOM_SEGMENTATION_INFO_KEY);
                    // If we already have the value then return that value
                    if (!!segmentationInfoJSONStr) {
                        return [2 /*return*/, JSON.parse(segmentationInfoJSONStr)];
                    }
                    return [4 /*yield*/, Promise.all(request === null || request === void 0 ? void 0 : request.requestList.map(function (requestCall) { return requestCall(); })).then(request === null || request === void 0 ? void 0 : request.mappingResponsesToSegmentationInfo, 
                        // If any of the requests fails then return null to indicate we should not init the Intercom
                        function () { return null; })];
                case 1:
                    segmentationInfo = _a.sent();
                    // Store the value in the session storage.
                    if (!!segmentationInfo) {
                        segmentationInfo.appId = request.appID;
                        segmentationInfo.lastApplicationName = INTERCOM_LAST_APPLICATION_NAME;
                        segmentationInfo.lastSeenPlatformDate = getLastSeenUnixEpoch();
                        sessionStorage.setItem(INTERCOM_SEGMENTATION_INFO_KEY, JSON.stringify(segmentationInfo));
                    }
                    return [2 /*return*/, segmentationInfo];
            }
        });
    });
};
/**
 * Removes any previous Intercom Segmentation Info from the session storage
 */
export var cleanIntercomSegmentationInfoCache = function () {
    sessionStorage.removeItem(INTERCOM_SEGMENTATION_INFO_KEY);
};
/**
 * Converts undefined values to null. Needed to register unknowns in intercom.
 */
export var undefinedToNull = function (value) {
    return value == undefined ? null : value;
};
export default {
    INTERCOM_SEGMENTATION_INFO_KEY: INTERCOM_SEGMENTATION_INFO_KEY,
    INTERCOM_LAST_APPLICATION_NAME: INTERCOM_LAST_APPLICATION_NAME,
    getLastSeenUnixEpoch: getLastSeenUnixEpoch,
    requestIntercomSegmentationInfoWithCache: requestIntercomSegmentationInfoWithCache,
    cleanIntercomSegmentationInfoCache: cleanIntercomSegmentationInfoCache,
    undefinedToNull: undefinedToNull,
};
